<template>
  <DataTable
    :title="title"
    :rows="mappedRows"
    :cols-map="{[translate('Domain')]: 'domain', [translate('Added')]: 'added'}"
    style="border-width: 1px"
    :loading="loading"
  >
    <template v-if="userStore.hasPermission('login-policy:write')" #actions="{rowid}">
      <td>
        <div class="align-middle d-inline-flex flex-shrink-0">
          <IconButton
            icon-name="material-symbols:delete-outline"
            class="text-danger"
            @click="$emit('delete', rowid)"
          />
        </div>
      </td>
    </template>
  </DataTable>
</template>
<script setup lang="ts">
import {Domain} from '@/api/apolloPlatform/loginPolicy';
import {useLocalisation} from '@/composables/useLocalisation';

const userStore = useUserStore();
const {translate, displayTimeStamp} = useLocalisation();

const props = defineProps<{
  title: string;
  rows: Domain[];
  loading: boolean;
}>();

defineEmits<{
  delete: [id: string];
}>();

const mappedRows = computed(() =>
  props.rows.map((r) => ({...r, added: displayTimeStamp(r.created)})),
);
</script>
